import React, { useState, useEffect } from "react";
import { Container, Row, Col, FormGroup, Label, Input, Table } from "reactstrap";
import { Formik, Form } from "formik";
import { useSearchParams } from "react-router-dom";
import * as Yup from "yup";
import { NumberWithCommas } from "../share/NumberWithCommas";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";



export function BorrowFollowSixComponent() {
    const [searchParams] = useSearchParams(); //searchParams.get('req')
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem("userData"))
    const [dataBorrowSixTest, setBorrowSixTest] = useState();
    const [dataTdPaymentTest, setDataTdPaymentTest] = useState({});
    const [disableButton, setDisableButton] = useState(true);
    const [dataTdPaymentTrain, setDataTdPaymentTrain] = useState({});
    const [sumTdPayment, setSumTdPayment] = useState(0);
    const [dataTdTrainTests, setDataTdTrainTests] = useState([]);
    // console.log("dataTdTrainTests", dataTdTrainTests);
    const [sumTdTrainTests, setSumTdTrainTests] = useState({
        paymentAmount: 0,
        personTotal: 0,
        actualPayment: 0,
        actualPerson: 0,
        passPerson: 0,
        balanceAmount: 0
    });

    const [checkTestFinish, setCheckTestFinish] = useState({});
    const [checkTrainFinish, setCheckTrainFinish] = useState({});

    // console.log("checkTestFinish", checkTestFinish)
    // console.log("checkTrainFinish", checkTrainFinish)

    useEffect(() => {
        if (checkTestFinish == null) {
            checkTrainFinish.trainFinish === "notpass" ? setDisableButton(true) : setDisableButton(false)
        }
        else if (checkTrainFinish == null) {
            checkTestFinish.testFinish === "notpass" ? setDisableButton(true) : setDisableButton(false)
        } else {

            checkTestFinish.testFinish === "notpass" || checkTrainFinish.trainFinish === "notpass" ? setDisableButton(true) : setDisableButton(false)
        }

    }, [checkTestFinish, checkTrainFinish])

    const [checkedTypeBorrow, setCheckedTypeBorrow] = useState([
        {
            id: "1",
            name: "one",
            check: false,
            var: "(1) เพื่อพัฒนาพนักงานให้มีทักษะ ความรู้มากขึ้น"

        },
        {
            id: "2",
            name: "two",
            check: false,
            var: "(2) เพื่อวัดระดับทักษะฝีมือของพนักงาน",

        },
        {
            id: "3",
            name: "three",
            check: false,
            var: "(3) เพื่อปรับเปลี่ยนตำแหน่ง หน้าที่ ของพนักงาน",
        },
        {
            id: "4",
            name: "four",
            check: false,
            var: "(4) เพื่อสร้างความก้าวหน้าในสายอาชีพแก่พนักงาน",
        },
        {
            id: "5",
            name: "five",
            check: false,
            var: "(5) เพื่อเพิ่มขีดความสามารถในการแข่งขันของบริษัท",
        },
        {
            id: "6",
            name: "six",
            check: false,
            var: "(6) เพื่อเพิ่มประสิทธิภาพการผลิต",
        },
        {
            id: "7",
            name: "seven",
            check: false,
            var: "(7) เพื่อลดต้นทุนการผลิต",
        },
        {
            id: "8",
            name: "eight",
            check: false,
            var: "(8) เพื่อร่วมมือกับภาครัฐพัฒนาทักษะฝีมือแรงงาน",
        },
    ]);


    useEffect(() => {
        GetBorrowSixTest()
    }, [])

    //โชว์ฝึกอบรม
    async function GetBorrowSixTest() {
        try {
            let postData = new FormData();
            postData.append("borrowId", searchParams.get('req'))
            const res = await fetch("/api/Borrow/getBorrowSixTest", {
                method: "POST",
                body: postData
            })
            const data = await res.json()
            setBorrowSixTest(data.dataenum);
            // console.log("dataenum", data.dataenum.tdPayments)
            // console.log("dataenum", data.dataenum.tdTrainTests)
            // console.log("dataenum", data.dataenum.checkTrainFinish)
            // console.log("dataenum", data.dataenum.checkTestFinish)
            setCheckTestFinish(data.dataenum.checkTestFinish)
            setCheckTrainFinish(data.dataenum.checkTrainFinish)
            setDataTdTrainTests(data.dataenum.tdTrainTests)

            setSumTdTrainTests(SumTdTrainTestsFX(data.dataenum.tdTrainTests))
            if (data.dataenum.checkSendForms !== null) {
                Swal.fire({
                    icon: "info",
                    title: "คุณได้นำส่งแบบติดตามประเมินผลการให้กู้ยืมเรียบร้อยแล้ว",
                    text: "",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate(`/borrowing/`)
                    }
                });
            }
            setDataTdPaymentTest(data.dataenum.tdPayments.filter((type) => type.paymentTypeId === 2))

            let sumtdPayments = 0;
            // console.log(`sumtdPayments`,sumtdPayments);
            // console.log("data.dataenum.tdPayments", data.dataenum.tdPayments);
            data.dataenum.tdPayments.map((row) => {
                // console.log(row);
                // console.log(row.ampere)
                sumtdPayments = sumtdPayments + row.amountApprove

            })
            // console.log("sumtdPayments", sumtdPayments);
            setSumTdPayment(sumtdPayments)


            setDataTdPaymentTrain(data.dataenum.tdPayments.filter(
                (type) => type.paymentTypeId === 1
            ))
        } catch (err) {
            // console.log(err);
        }
    }
    // console.log("borrowSixTest", dataBorrowSixTest)

    const fromInitialValues = {
        RegisterId: user.registerId,
        BorrowId: searchParams.get('req'),
        BorrowReason1: [],
        BorrowReason2P1: 0,
        BorrowReason2P2: 0,
        BorrowReason2P3: 0,
        BorrowReason2P4: 0,
        BorrowReason2P5: 0,
        BorrowReason2P6: 0,
        BorrowReason2P7: 0,
        BorrowReason2P8: 0,
        BorrowReason3P1: 0,
        BorrowReason3P2: 0,
        BorrowReason3P3: 0,
        BorrowReason3P4: 0,
        BorrowReason3P5: 0,
        BorrowReason3P6: 0,
        BorrowReason3P7: 0,
        BorrowReason4P1: 0,
        BorrowReason4P2: 0,
        BorrowReason4P3: 0,
        BorrowReason4P4: 0,
        BorrowReason4P5: 0,
        BorrowReason4P6: 0,
        BorrowReason4P7: 0,
        BorrowReason51: 0,
        BorrowReason511: "",
        BorrowReason52: 0,
        BorrowReason521: 0,
        BorrowReason522: "",
        BorrowReason53: 0,
        BorrowReason531: "",
        BorrowReason54: 0,
        BorrowReason541: "",
        BorrowReason55: "",
        BorrowReason56: "",
        SumTdActualPayment: 0,
        TdTrainTests: [],
        // fActualExpensePath: ""
    }
    //.zip .rar
    const zipCT = ["application/zip", "application/octet-stream", "application/x-zip-compressed", "multipart/x-zip", "application/vnd.rar", "application/x-rar-compressed", "application/octet-stream"]
    const validateSchema = Yup.object().shape({
        BorrowReason1: Yup.array().min(1, "กรุณาเลือกอย่างน้อย 1 รายการ"),
        SumTdActualPayment: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P1: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P2: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P3: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P4: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P5: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P6: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P7: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason2P8: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P1: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P2: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P3: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P4: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P5: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P6: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason3P7: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P1: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P2: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P3: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P4: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P5: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P6: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason4P7: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason51: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason511: Yup.string(),
        BorrowReason52: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason521: Yup.number(),
        BorrowReason522: Yup.string(),
        BorrowReason53: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason531: Yup.string(),
        BorrowReason54: Yup.number().min(1, "กรุณาระบุ"),
        BorrowReason541: Yup.string().when("BorrowReason54", {
            is: 3,
            then: Yup.string().required("กรุณาระบุ"),
        }),
        BorrowReason55: Yup.string(),
        BorrowReason56: Yup.string(),
        TdTrainTests: Yup.array(),
        BorrowId: Yup.number(),
        // fActualExpensePath: Yup.mixed().test('fileFormat', 'เฉพาะไฟล์ชนิด .zip หรือ .rar', (value) => {
        //     // console.log(value)
        //     return value && zipCT.includes(value.type);
        // }).required("กรุณาแนบไฟล์")

    });

    const onSubmit = async (values, actions) => {
        // console.log("values", values);
        let postData = new FormData();
        values.TdTrainTests = dataTdTrainTests;
        // Object.entries(values).forEach(([key, value]) => {
        //     postData.append(key, value);
        // });
        // console.log("onSubmit")
        // console.log(values)
        try {
            let res = await fetch("/api/Borrow/saveFromBorrowSixPoint", {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify(values)
                // body: postData,
            });

            let resJson = await res.json();
            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate(`/borrowing/`)
                    }
                });

            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
            // console.log(resJson.dataenum)
            // alert(resJson.message)

        } catch (e) {
            // console.log(e)
        }
    }

    function SumTdTrainTestsFX(data) {
        let preSumTdTrainTests = {
            paymentAmount: 0,
            personTotal: 0,
            actualPayment: 0,
            actualPerson: 0,
            passPerson: 0,
            balanceAmount: 0
        };

        data.map((row) => {
            // console.log("row", row)
            preSumTdTrainTests.paymentAmount = preSumTdTrainTests.paymentAmount + row.paymentAmount
            preSumTdTrainTests.personTotal = preSumTdTrainTests.personTotal + row.personTotal
            preSumTdTrainTests.actualPayment = preSumTdTrainTests.actualPayment + row.actualPayment
            preSumTdTrainTests.actualPerson = preSumTdTrainTests.actualPerson + row.actualPerson
            preSumTdTrainTests.passPerson = preSumTdTrainTests.passPerson + row.passPerson
            preSumTdTrainTests.balanceAmount = preSumTdTrainTests.balanceAmount + row.balanceAmount

        })

        return preSumTdTrainTests
    }


    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={fromInitialValues}
            validationSchema={validateSchema}
            enableReinitialize
        >
            {({ values, errors, touched, setFieldValue, setValues, handleBlur, handleChange, handleSubmit, submitForm, setFieldError }) => {
                // console.log("values", values)
                /*console.log("testdata", resJson)*/
                const SelectType = (types) => {
                    const filtered = types.filter(type => type.check === true) // เลือกค่า state ที่มีค่าเป็น true แล้วให้โชว์แค่ตัวเดียว ก็คือ index 0
                    let typesResult = filtered.map(({ id }) => id);
                    setFieldValue("BorrowReason1", typesResult)
                    // console.log(typesResult)
                    // setTypeBorrow(typesResult);
                };
                const HandleChecked = (e) => {
                    const { target } = e;
                    const { value, checked } = target;
                    /*                    console.log("value", value)*/

                    const index = checkedTypeBorrow.findIndex((type) => type.id === value);
                    checkedTypeBorrow[index].check = checked;
                    setCheckedTypeBorrow([...checkedTypeBorrow]);
                    SelectType(checkedTypeBorrow);
                };
                /*                console.log("testcheck", values)*/
                const setValueTrainTests = (e) => {
                    // console.log("setValueTrainTests");
                    let getPaymentType = e.target.id[1]
                    let getInputType = e.target.id[0]
                    let getItemId = e.target.id.split("_")[1]

                    // console.log(getPaymentType)
                    // console.log(getInputType)
                    // console.log(getItemId)

                    const preDataBorrowSixTest = dataTdTrainTests?.map((item, i) => {
                        // console.log(item)
                        if (item.paymentTypeId == getPaymentType) {

                            if (getInputType == 'a') {
                                if (item.itemId == getItemId) {
                                    item.actualPayment = Number(e.target.value)
                                    item.balanceAmount = Number(item.paymentAmount) - Number(item.actualPayment)
                                }
                            } else if (getInputType == 'p') {
                                if (item.itemId == getItemId) {
                                    item.actualPerson = Number(e.target.value)
                                }
                            } else if (getInputType == 'r') {
                                if (item.itemId == getItemId) {
                                    item.passPerson = Number(e.target.value)
                                }
                            }

                        }

                        return item
                    });
                    // console.log("preDataBorrowSixTest", preDataBorrowSixTest);
                    setDataTdTrainTests(preDataBorrowSixTest)

                    setSumTdTrainTests(SumTdTrainTestsFX(preDataBorrowSixTest))

                    // console.log("preDataBorrowSixTest", preDataBorrowSixTest);

                    values.TdTrainTests = preDataBorrowSixTest

                }

                const checkSumActual = () => {

                    let check = true


                    // if (sumTdTrainTests.actualPayment == 0 || sumTdTrainTests.actualPerson == 0 || sumTdTrainTests.passPerson == 0) {
                    //     check = false
                    //     setFieldError("TdTrainTests", "กรุณาระบุ")
                    // }

                    // if (values.SumTdActualPayment != sumTdTrainTests.actualPayment) {
                    //     check = false
                    //     setFieldError("TdTrainTests", "จำนวนเงินการใช้จ่ายเงินกู้ยืมตามที่เบิกจ่ายจริงไม่ถูกต้อง")
                    // }
                    if (check) {
                        submitForm()
                    }

                }

                // console.log("checkpoint", values)
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        <div className="form-border">
                            <Form className="p-5 mb-4">

                                <Label className="me-4 input-color">
                                    ประเภทผู้กู้ยืมเงิน
                                </Label>
                                <FormGroup className="px-3">
                                    <Col >
                                        {dataBorrowSixTest?.borrowType.map((dataType, i) =>
                                            <p className="text-center rounded-pill border py-1 input-color" >
                                                {dataType.typeName}
                                            </p>
                                        )}

                                    </Col>
                                </FormGroup>
                                <Label className="me-4 input-color">
                                    ส่วนที่ 1 ข้อมูลทั่วไป
                                </Label>
                                <div className="p-3">
                                    <FormGroup>
                                        <Label>
                                            ชื่อผู้กู้ยืม
                                        </Label>
                                        <Col >
                                            <p className="text-center rounded-pill border py-1 input-color" >
                                                {dataBorrowSixTest?.borrowName}
                                            </p>
                                        </Col>
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>
                                            เลขที่สัญญา
                                        </Label>
                                        <Col>
                                            <p className="text-center rounded-pill border py-1 input-color" >
                                                {dataBorrowSixTest?.contactNumber}
                                            </p>
                                        </Col>
                                    </FormGroup>
                                </div>
                                {/*เลือกเหตุผล checkbox */}
                                <Label className="me-4 input-color">
                                    เหตุผลของการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเป็นค่าใช้จ่ายในการฝึกอบรม/ทดสอบมาตรฐานฝีมือแรงงาน
                                    (ตอบได้มากกว่า 1 ข้อ)  {errors.BorrowReason1 ? (
                                        <span className="text-left text-danger mx-1">
                                            {errors.BorrowReason1}
                                        </span>
                                    ) : null}
                                </Label>
                                <div className="d-flex justify-content-around flex-column">
                                    <FormGroup className="mx-2">
                                        <Input
                                            id="one"
                                            type="checkbox"
                                            className="mx-2 cus-type"
                                            value="1"
                                            name="one"
                                            onClick={HandleChecked} />

                                        <Label>(1) เพื่อพัฒนาพนักงานให้มีทักษะ ความรู้มากขึ้น </Label>
                                    </FormGroup>
                                    <FormGroup className="mx-2">
                                        <Input
                                            id="two"
                                            type="checkbox"
                                            className="mx-2 cus-type"
                                            value="2"
                                            name="two"
                                            onClick={HandleChecked} />

                                        <Label>(2) เพื่อวัดระดับทักษะฝีมือของพนักงาน</Label>
                                    </FormGroup>
                                    <FormGroup className="mx-2">
                                        <Input
                                            id="three"
                                            type="checkbox"
                                            className="mx-2 cus-type"
                                            value="3"
                                            name="three"
                                            onClick={HandleChecked} />

                                        <Label>(3) เพื่อปรับเปลี่ยนตำแหน่ง หน้าที่ ของพนักงาน</Label>
                                    </FormGroup>
                                    <FormGroup className="mx-2">
                                        <Input
                                            id="four"
                                            type="checkbox"
                                            className="mx-2 cus-type"
                                            value="4"
                                            name="four"
                                            onClick={HandleChecked} />

                                        <Label>(4) เพื่อสร้างความก้าวหน้าในสายอาชีพแก่พนักงาน</Label>
                                    </FormGroup>
                                    <FormGroup className="mx-2">
                                        <Input
                                            id="five"
                                            type="checkbox"
                                            className="mx-2 cus-type"
                                            value="5"
                                            name="five"
                                            onClick={HandleChecked} />

                                        <Label>(5) เพื่อเพิ่มขีดความสามารถในการแข่งขันของบริษัท </Label>
                                    </FormGroup>
                                    <FormGroup className="mx-2">
                                        <Input
                                            id="six"
                                            type="checkbox"
                                            className="mx-2 cus-type"
                                            value="6"
                                            name="six"
                                            onClick={HandleChecked} />
                                        <Label>(6) เพื่อเพิ่มประสิทธิภาพการผลิต</Label>
                                    </FormGroup>
                                    <FormGroup className="mx-2">
                                        <Input
                                            id="seven"
                                            type="checkbox"
                                            className="mx-2 cus-type"
                                            value="7"
                                            name="seven"
                                            onClick={HandleChecked} />

                                        <Label>(7) เพื่อลดต้นทุนการผลิต</Label>
                                    </FormGroup>
                                    <FormGroup className="mx-2">
                                        <Input
                                            id="eight"
                                            type="checkbox"
                                            className="mx-2 cus-type"
                                            value="8"
                                            name="eight"
                                            onClick={HandleChecked} />
                                        <Label>(8) เพื่อร่วมมือกับภาครัฐพัฒนาทักษะฝีมือแรงงาน</Label>
                                    </FormGroup>
                                </div>

                                {/*จำนวนเงิน*/}
                                <FormGroup>
                                    <Label>
                                        จำนวนเงินกู้ตามสัญญา
                                    </Label>
                                    <Col>
                                        <p className="text-center rounded-pill border py-1 input-color" >
                                            {NumberWithCommas(sumTdPayment)} บาท
                                        </p>
                                    </Col>
                                </FormGroup>

                                <div className="p-3">
                                    <FormGroup>
                                        <Label>ดำเนินการฝึกอบรมผีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545</Label>
                                        <Row className="pt-3 mx-3">
                                            <Label sm={1}>จำนวน</Label>
                                            <Col className="pt-2 text-center input-color" sm={1} >
                                                {dataTdPaymentTrain[0]?.course ?? "-"}
                                            </Col>
                                            <Label sm={2}>หลักสูตร</Label>
                                            <Label sm={1}>จำนวน</Label>
                                            <Col className="pt-2 text-center input-color" sm={2}>
                                                {dataTdPaymentTrain[0]?.personTotal ?? "-"}
                                            </Col>
                                            <Label sm={2}>คน</Label>
                                        </Row>
                                    </FormGroup>
                                    {/* )} */}
                                </div>
                                <div className="p-3">
                                    <FormGroup>
                                        <Label>ดำเนินการทดสอบมาตรฐานผีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545</Label>
                                        <Row className="pt-3 mx-3">
                                            <Label sm={1}>จำนวน</Label>
                                            <Col className="pt-2 text-center input-color" sm={1}>
                                                {dataTdPaymentTest[0]?.course ?? "-"}
                                            </Col>
                                            <Label sm={2}>สาขาอาชีพ</Label>
                                            <Label sm={1}>จำนวน</Label>
                                            <Col className="pt-2 text-center input-color" sm={2}>
                                                {dataTdPaymentTest[0]?.personTotal ?? "-"}
                                            </Col>
                                            <Label sm={2}>คน</Label>
                                        </Row>
                                    </FormGroup>
                                    {/* )} */}
                                </div>
                                {/*การใช้จ่าย*/}
                                <FormGroup>
                                    <Label>
                                        การใช้จ่ายเงินกู้ตามที่เบิกจ่ายจริง (บาท)
                                        {errors.SumTdActualPayment ? (
                                            <span className="text-left text-danger mx-1">
                                                {errors.SumTdActualPayment}
                                            </span>
                                        ) : null}
                                    </Label>
                                    <Col>
                                        <Input
                                            type="text"
                                            className=" text-center input-color rounded-pill"
                                            name="SumTdActualPayment"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.SumTdActualPayment}
                                        />
                                    </Col>
                                </FormGroup>
                                {/* <Row className="pt-1 ">
                                    <Label sm={4}> การใช้จ่ายเงินกู้ตามที่เบิกจ่ายจริง
                                        {errors.SumTdActualPayment ? (
                                            <span className="text-left text-danger mx-1">
                                                {errors.SumTdActualPayment}
                                            </span>
                                        ) : null}
                                    </Label>
                                    <Col className="pt-2 text-center" sm={3}>
                                        <Input
                                            type="text"
                                            className=" text-center input-color rounded-pill"
                                            name="SumTdActualPayment"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.SumTdActualPayment}
                                        />
                                    </Col>
                                    <Label sm={3} className="text-left">บาท</Label>
                                </Row> */}
                                {/*ส่วนที่2*/}
                                <Label className="input-color pt-3"
                                    name="">
                                    ส่วนที่ 2 ประโยชน์ที่ผู้ประกอบกิจการได้รับจากการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน เพื่อดำเนินการฝึกอบรม/ทดสอบมาตรฐานฝีมือแรงงาน
                                </Label>
                                <div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2 ">1.ลดต้นทุน/ลดการสูญเสียในการผลิต
                                            {errors.BorrowReason2P1 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason2P1}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason2P1"
                                            name="BorrowReason2P1"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason2P1}
                                        >
                                            <option defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">2.เพิ่มผลิตภาพการผลิตสินค้า/บริการ
                                            {errors.BorrowReason2P2 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason2P2}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason2P"
                                            name="BorrowReason2P2"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason2P2}
                                        >
                                            <option defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">3.สินค้า/บริการ มีคุณภาพดีขึ้น
                                            {errors.BorrowReason2P3 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason2P3}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason2P3"
                                            name="BorrowReason2P3"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason2P3}
                                        >
                                            <option defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">4.เพิ่มความสามารถในการแข่งขันของบริษัท
                                            {errors.BorrowReason2P4 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason2P4}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason2P4"
                                            name="BorrowReason2P4"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason2P4}
                                        >
                                            <option defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">5.พนักงานมีทักษะ ความรู้ ความชำนาญเพิ่มขึ้น
                                            {errors.BorrowReason2P5 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason2P5}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason2P5"
                                            name="BorrowReason2P5"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason2P5}
                                        >
                                            <option defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">6.ความผิดพลาดในการทำงานลดลง
                                            {errors.BorrowReason2P6 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason2P6}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason2P6"
                                            name="BorrowReason2P6"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason2P6}
                                        >
                                            <option defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">7.สามารถจำแนกระดับความรู้ความสามารถพนักงานในองค์กร
                                            {errors.BorrowReason2P7 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason2P7}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason2P7"
                                            name="BorrowReason2P7"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason2P7}
                                        >
                                            <option defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">8.สามารถปรับเพิ่มเงินเดือน เลื่อนตำแหน่งตามทักษะความรู้ความสามารถ
                                            {errors.BorrowReason2P8 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason2P8}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason2P8"
                                            name="BorrowReason2P8"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason2P8}
                                        >
                                            <option defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                </div>
                                {/*ส่วนที่3*/}
                                <Label className="me-4 pt-3 input-color">
                                    ส่วนที่ 3 ประโยชน์ที่พนักงานได้รับจากการฝึกอบรม/ทดสอบมาตรฐานฝีมือแรงงาน
                                </Label>
                                <div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2 ">1.มีทักษะความรู้ความชำนาญในงานที่ทำเพิ่มขึ้น
                                            {errors.BorrowReason3P1 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason3P1}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason3P1"
                                            name="BorrowReason3P1"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason3P1}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">2.รู้ระดับความสามารถของตนเองเพื่อพัฒนาสมรรถนะที่ขาด
                                            {errors.BorrowReason3P2 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason3P2}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason3P2"
                                            name="BorrowReason3P2"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason3P2}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">3.พัฒนาความรู้ความสามารถทันต่อเทคโนโลยี
                                            {errors.BorrowReason3P3 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason3P3}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason3P3"
                                            name="BorrowReason3P3"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason3P3}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">4.สามารถถ่ายทอดความรู้และสอนงานในพนักงานในองค์กร
                                            {errors.BorrowReason3P4 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason3P4}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason3P4"
                                            name="BorrowReason3P4"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason3P4}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">5.การทำงานแบบระบบมีประสิทธิภาพเพิ่มขึ้น
                                            {errors.BorrowReason3P5 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason3P5}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason3P5"
                                            name="BorrowReason3P5"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason3P5}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">6.สามารถแก้ไขปัญหาข้อขัดข้องในการปฎิบัติงานได้
                                            {errors.BorrowReason3P6 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason3P6}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason3P6"
                                            name="BorrowReason3P6"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason3P6}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">7.ได้รับการปรับเพิ่มเงินเดือน เลื่อนตำแหน่งงานสูงขึ้น
                                            {errors.BorrowReason3P7 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason3P7}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason3P7"
                                            name="BorrowReason3P7"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason3P7}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                </div>
                                {/*ส่วนที่4*/}
                                <Label className="me-4 pt-3 input-color">
                                    ส่วนที่ 4 ประโยชน์ที่พนักงานได้รับจากการฝึกอบรม/ทดสอบมาตรฐานฝีมือแรงงาน
                                </Label>
                                <div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2 ">1.ให้คำปรึกษาแนะนำชี้แจงหลักเกณฑ์การให้กู้ยืมเงินกองทุนอย่างถูกต้อง ชัดเจน เข้าใจง่าย
                                            {errors.BorrowReason4P1 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason4P1}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason4P1"
                                            name="BorrowReason4P1"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason4P1}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">2.อำนวยความสะดวกในการจัดทำเอกสารการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
                                            {errors.BorrowReason4P2 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason4P2}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason4P2"
                                            name="BorrowReason4P2"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason4P2}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">3.มีความกระตือรือร้นและเต็มใจให้บริการด้วยความรวดเร็ว
                                            {errors.BorrowReason4P3 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason4P3}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason4P3"
                                            name="BorrowReason4P3"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason4P3}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">4.สามารถตอบคำถาม ช่วยเหลือเมื่อมีข้อสงสัย
                                            {errors.BorrowReason4P4 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason4P4}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason4P4"
                                            name="BorrowReason4P4"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason4P4}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">5.ช่องทางการชำระเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงานมีความสะดวก
                                            {errors.BorrowReason4P5 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason4P5}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason4P5"
                                            name="BorrowReason4P5"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason4P5}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">6.ขั้นตอนการให้บริการมีความสะดวก รวดเร็ว
                                            {errors.BorrowReason4P6 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason4P6}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason4P6"
                                            name="BorrowReason4P6"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason4P6}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                    <div className="d-flex justify-content-between border rounded-pill m-1">
                                        <div className="mx-3 pt-2">7.การประชาสัมพันธ์ข้อมูลข่าวสารการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
                                            {errors.BorrowReason4P7 ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.BorrowReason4P7}
                                                </span>
                                            ) : null}
                                        </div>
                                        <Input
                                            id="BorrowReason4P7"
                                            name="BorrowReason4P7"
                                            type="select"
                                            className={touched.companyProvinceCode && errors.companyProvinceCode ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill w-auto  text-center input-color"}
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason4P7}
                                        >
                                            <option className="text-dark" defaultValue value="0">กรุณาเลือก</option>
                                            <option value="5">มากที่สุด</option>
                                            <option value="4">มาก</option>
                                            <option value="3">ปานกลาง</option>
                                            <option value="2">น้อย</option>
                                            <option value="1">น้อยที่สุด</option>
                                        </Input>
                                    </div>
                                </div>
                                {/*ส่วนที่5*/}
                                <Label className="me-4 pt-2 input-color">
                                    ส่วนที่ 5 อื่นๆ
                                </Label>
                                <div className="p-3">
                                    <Label className="me-4">
                                        1.ท่านมีความประสงค์จะใช้บริการเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงาน เพื่อนำไปฝึกอบรม/ทดสอบมาตรฐานฝีมือแรงงานเพื่อพัฒนาทักษะความรู้ให้แก่พนักงาน เพิ่มเติมหรือไม่
                                        {errors.BorrowReason51 ? (
                                            <span className="text-left text-danger mx-1">
                                                {errors.BorrowReason51}
                                            </span>
                                        ) : null}
                                    </Label>
                                    <Row className="pt-2 px-2">
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason51"
                                                name="BorrowReason51"
                                                type="radio"
                                                className="cus-type"
                                                value="1"
                                                onClick={handleChange}
                                            /> <Label>ต้องการ</Label>
                                        </Col>
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason51"
                                                name="BorrowReason51"
                                                type="radio"
                                                className="cus-type"
                                                value="2"
                                                onClick={handleChange}
                                            /> <Label>ไม่ต้องการ</Label>
                                        </Col>
                                    </Row>
                                    <Label
                                        className="pt-2 px-2"
                                        sm={2}>
                                        เนื่องจาก
                                    </Label>
                                    <Col sm={12}>
                                        <Input
                                            id="BorrowReason511"
                                            name="BorrowReason511"
                                            type="text"
                                            className=" text-center input-color rounded-pill"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason511}
                                        />
                                    </Col>
                                    <Label className="pt-3">
                                        2.ท่านคิดว่าอัตราดอกเบี้ยเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงานร้อยละ 3 ต่อปี มีความเหมาะสมหรือไม่
                                        {errors.BorrowReason52 ? (
                                            <span className="text-left text-danger mx-1">
                                                {errors.BorrowReason52}
                                            </span>
                                        ) : null}
                                    </Label>
                                    <Row className="pt-2 px-2">
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason52"
                                                name="BorrowReason52"
                                                type="radio"
                                                className="cus-type"
                                                value="1"
                                                onClick={handleChange}

                                            /> <Label>เหมาะสม</Label>
                                        </Col>
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason52"
                                                name="BorrowReason52"
                                                type="radio"
                                                className="cus-type"
                                                value="2"
                                                onClick={handleChange}

                                            /> <Label>ไม่เหมาะสม</Label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Label className="pt-2 mx-2"
                                            for=""
                                            sm={4}
                                        >
                                            อัตราที่เหมาะสม คือ ร้อยละ
                                        </Label>
                                        <Col sm={2}>
                                            <Input
                                                id="BorrowReason521"
                                                name="BorrowReason521"
                                                type="number"
                                                className="rounded-pill text-center input-color"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                value={values.BorrowReason521}
                                            />
                                        </Col>
                                        <Label sm={2}> ต่อปี </Label>
                                    </Row>
                                    <Label className="mx-2" sm={2}>
                                        เนื่องจาก
                                    </Label>
                                    <Col sm={12}>
                                        <Input
                                            id="BorrowReason522"
                                            name="BorrowReason522"
                                            type="text"
                                            className=" text-center input-color rounded-pill"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason522}
                                        />
                                    </Col>

                                    <Label className="pt-3">
                                        3.ท่านคิดว่าเงินกู้ยืมกองทุนพัฒนาฝีมือแรงงานมีประโยชน์ต่อการส่งเสริมการพัฒนาฝีมือแรงงานหรือไม่
                                        {errors.BorrowReason53 ? (
                                            <span className="text-left text-danger mx-1">
                                                {errors.BorrowReason53}
                                            </span>
                                        ) : null}
                                    </Label>
                                    <Row className="pt-2 px-2">
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason53"
                                                name="BorrowReason53"
                                                type="radio"
                                                className="cus-type"
                                                value="1"
                                                onClick={handleChange}

                                            /> <Label>มีประโยชน์</Label>
                                        </Col>
                                        <Col sm={3}>
                                            <Input
                                                id="BorrowReason53"
                                                name="BorrowReason53"
                                                type="radio"
                                                className="cus-type"
                                                value="2"
                                                onClick={handleChange}

                                            /> <Label>ไม่มีประโยชน์</Label>
                                        </Col>
                                    </Row>
                                    <Label className="mx-2" sm={2}>
                                        เนื่องจาก
                                    </Label>
                                    <Col sm={12}>
                                        <Input
                                            id="BorrowReason531"
                                            name="BorrowReason531"
                                            type="text"
                                            className=" text-center input-color rounded-pill"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason531}
                                        />
                                    </Col>
                                    <Label className="pt-3">
                                        4. ทราบข่าวสารการให้กู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานจาก
                                        {errors.BorrowReason54 ? (
                                            <span className="text-left text-danger mx-1">
                                                {errors.BorrowReason54}
                                            </span>
                                        ) : null}
                                    </Label>
                                    <Row className="pt-2 px-2">
                                        <Col>
                                            <Input
                                                id="BorrowReason54"
                                                name="BorrowReason54"
                                                type="radio"
                                                className="cus-type"
                                                value="1"
                                                onClick={handleChange}

                                            /> <Label>เจ้าหน้าที่กรมพัฒนาฝีมือแรงงาน</Label>
                                        </Col>
                                    </Row>
                                    <Row className="pt-2 px-2">
                                        <Col>
                                            <Input
                                                id="BorrowReason54"
                                                name="BorrowReason54"
                                                type="radio"
                                                className="cus-type"
                                                value="2"
                                                onClick={handleChange}

                                            /> <Label>Internet</Label>
                                        </Col>
                                    </Row>
                                    <Row className="pt-2 px-2">
                                        <Col>
                                            <Input
                                                id="BorrowReason54"
                                                name="BorrowReason54"
                                                type="radio"
                                                className="cus-type"
                                                value="3"
                                                onClick={handleChange}

                                            /> <Label>อื่นๆ โปรดระบุ
                                                {errors.BorrowReason541 ? (
                                                    <span className="text-left text-danger mx-1">
                                                        {errors.BorrowReason541}
                                                    </span>
                                                ) : null}
                                            </Label>
                                        </Col>
                                    </Row>
                                    <Col sm={12}>
                                        <Input
                                            id="BorrowReason541"
                                            name="BorrowReason541"
                                            type="text"
                                            className=" text-center input-color rounded-pill"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values.BorrowReason541}
                                        />
                                    </Col>

                                    <Row>
                                        <Label className="pt-3">
                                            5.ปัญหาอุปสรรคการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน
                                        </Label>
                                        <Col sm={12}>
                                            <Input
                                                id="BorrowReason55"
                                                name="BorrowReason55"
                                                type="text"
                                                className=" text-center input-color rounded-pill"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                value={values.BorrowReason55}
                                            />
                                        </Col>
                                    </Row>
                                    <Row >
                                        <Label className="pt-3">
                                            6.ข้อคิดเห็นและข้อเสนอแนะ
                                        </Label>
                                        <Col sm={12}>
                                            <Input
                                                id="BorrowReason56"
                                                name="BorrowReason56"
                                                type="text"
                                                className=" text-center input-color rounded-pill"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                value={values.BorrowReason56}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                                {/*สรุปค่าใช้จ่าย*/}
                                <Row className="pt-2 px-2">
                                    <Label className="me-4 input-color">
                                        สรุปค่าใช้จ่ายในการดำเนินการ
                                    </Label>
                                    {errors.TdTrainTests ? (
                                        <span className="text-left text-danger mx-1">
                                            {errors.TdTrainTests}
                                        </span>
                                    ) : null}
                                </Row>
                                <Table className="styled-table" striped bordered hover>
                                    <thead className="text-center" style={{ verticalAlign: "top" }}>
                                        <tr>
                                            <th colSpan={2} rowSpan={2} className="text-center">ลำดับ</th>
                                            <th colSpan={2} rowSpan={2} className="text-center">ชื่อหลักสูตร/สาขาอาชีพ</th>
                                            <th colSpan={2} className="text-center" >วงเงินกู้ตามสัญญากู้ยืมเงิน</th>
                                            <th colSpan={3} className="text-center">การใช้จ่ายเงินกู้ยืมตามที่เบิกจ่ายจริง</th>
                                            <th colSpan={3} rowSpan={2} className="text-center">จำนวนเงินกู้ยืมคงเหลือจากการเบิกจ่ายจริง(ถ้ามี)</th>
                                        </tr>
                                        <tr>
                                            <th>จำนวนเงิน</th>
                                            <th>จำนวนคนเข้าฝึกอบรม/ทดสอบฯ</th>
                                            <th>จำนวนเงิน</th>
                                            <th>จำนวนคนเข้าฝึกอบรม/ทดสอบฯ</th>
                                            <th>จำนวนผู้ผ่านการฝึกอบรม/ทดสอบฯ</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dataTdTrainTests?.map((item, i) =>
                                            <tr>
                                                <td colSpan={2} className="text-center">{i + 1}</td>
                                                <td colSpan={2}>{item.itemName}</td>
                                                <td colSpan={1}>{NumberWithCommas(item.paymentAmount)}</td>
                                                <td colSpan={1}>{NumberWithCommas(item.personTotal)}</td>
                                                <td colSpan={1}>
                                                    <Input
                                                        type="text"
                                                        className=" text-center input-color rounded-pill"
                                                        name={'a' + item.paymentTypeId + '_' + item.itemId}
                                                        id={'a' + item.paymentTypeId + '_' + item.itemId}
                                                        value={item.actualPayment}
                                                        onChange={(e) => setValueTrainTests(e)}
                                                    />
                                                </td>
                                                <td colSpan={1}>
                                                    <Input
                                                        type="text"
                                                        className=" text-center input-color rounded-pill"
                                                        name={'p' + item.paymentTypeId + '_' + item.itemId}
                                                        id={'p' + item.paymentTypeId + '_' + item.itemId}
                                                        value={item.actualPerson}
                                                        onChange={(e) => setValueTrainTests(e)}
                                                    />
                                                </td>
                                                <td colSpan={1}>
                                                    <Input
                                                        type="text"
                                                        className=" text-center input-color rounded-pill"
                                                        name={'r' + item.paymentTypeId + '_' + item.itemId}
                                                        id={'r' + item.paymentTypeId + '_' + item.itemId}
                                                        value={item.passPerson}
                                                        // value={item.actualPerson}
                                                        onChange={(e) => setValueTrainTests(e)}
                                                    />
                                                </td>
                                                <td colSpan={2}>
                                                    {NumberWithCommas(item.balanceAmount)}
                                                </td>
                                            </tr>
                                        )}

                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colSpan={4}>รวม</td>
                                            <td colSpan={1}>{NumberWithCommas(sumTdTrainTests.paymentAmount)}</td>
                                            <td colSpan={1}>{NumberWithCommas(sumTdTrainTests.personTotal)}</td>
                                            <td colSpan={1}>{NumberWithCommas(sumTdTrainTests.actualPayment)}</td>
                                            <td colSpan={1}>{NumberWithCommas(sumTdTrainTests.actualPerson)}</td>
                                            <td colSpan={1}>{NumberWithCommas(sumTdTrainTests.passPerson)}</td>
                                            <td colSpan={2}>{NumberWithCommas(sumTdTrainTests.balanceAmount)}</td>
                                        </tr>
                                    </tfoot>
                                </Table>
                                {/* <div>
                                    <Label className="text-left">หลักฐานการจ่ายค่าใช้จ่ายที่เกี่ยวข้อง *</Label>
                                    {errors.fActualExpensePath ? (
                                        <span className="text-left text-danger mx-1">
                                            {errors.fActualExpensePath}
                                        </span>
                                    ) : null}
                                    <Input
                                        name="fActualExpensePath"
                                        type="file"
                                        onBlur={handleBlur}
                                        className={
                                            touched.fActualExpensePath && errors.fActualExpensePath
                                                ? "input-error rounded-pill text-center input-color"
                                                : "rounded-pill text-center input-color"
                                        }
                                        onChange={(e) => {
                                            handleChange(e)
                                            if (e.target && e.target.files[0]) {
                                                setFieldValue(`fActualExpensePath`, e.target.files[0]);
                                            }
                                        }}
                                    />
                                </div> */}

                                <div className="text-center mt-4">
                                    <button
                                        disabled={disableButton}
                                        className="submit-btn w-50"
                                        type="button"
                                        onClick={() => checkSumActual()}
                                    >
                                        บันทึกข้อมูล
                                    </button>
                                </div>
                            </Form>
                        </div>

                        {/* )} */}

                    </Container>

                );
            }}
        </Formik>
    );


}
